/* eslint-disable import/prefer-default-export */
import { OrgChart } from '../../types';

export const getActive = (active: string | undefined, value: OrgChart) => {
  if (!active) return undefined;

  const user = value.users[active];
  const mapping = value.orgChart[active];

  if (!user) return undefined;

  return {
    id: active,
    ...user,
    reports: mapping.reports || [],
    manager: mapping.manager,
  };
};
